import * as React from "react";

function SvgSearch(props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) {
  return <svg viewBox="0 0 16 16" ref={svgRef} {...props}><path d="M6.535 2.249a4.3 4.3 0 104.292 4.3 4.3 4.3 0 00-4.292-4.3zM15.7 13.806a.706.706 0 010 1.153l-.782.784c-.475.343-.808.343-1.149 0l-3.658-3.667a6.406 6.406 0 01-3.485 1.032c-.025 0-.048-.007-.072-.007h-.02a6.552 6.552 0 116.536-6.55v.032s.006.043.006.064a6.438 6.438 0 01-1.032 3.492z" fill="currentColor" fillRule="evenodd" /></svg>;
}

const ForwardRef = React.forwardRef(SvgSearch);
export default ForwardRef;